import React from 'react';
import { ReactComponent as AccentButtonSvg } from './accent-button-stripes_wide.svg';
import './BrandedButton.css';

/**
 * BrandedButton
 * A branded button component that renders the complete accent button SVG.
 * Similar to the footer LogoButton approach.
 */
export default function BrandedButton({ className, onClick, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={`branded-button-wrapper ${className || ''}`}
            onClick={onClick}
            role="button"
            tabIndex={0}
            {...props}
        >
            <AccentButtonSvg />
        </div>
    );
}
